<template>
  <div class="DrkWhite pa-4">
      <h2 class="subheading green--text">Users</h2>
      <v-card class="mt-4">
      <User/>
  </v-card>
  </div>
</template>

<script>
import User from '@/components/Utils/User.vue'
  export default {
    components: {
      User
    },
    data: () => ({
    }),
  }
</script>

<style scoped>
</style>